// extracted by mini-css-extract-plugin
module.exports = {"video_container":"GuideVideoModal_video_container__1diyU","video":"GuideVideoModal_video__1I7Ys"};